import React, { useState } from 'react';

const STRIPE_MONTHLY = 'https://buy.stripe.com/4gMaEW7lb0sOcPDa7q5ZC04';
const STRIPE_ANNUAL  = 'https://buy.stripe.com/3cIaEWgVL1wSg1P3J25ZC03';

function SubscribeModal({ onClose, session }) {
  const [plan, setPlan] = useState('monthly');

  // Append client_reference_id so the webhook can link payment to this user
  const userId = session?.user?.id;
  const baseUrl = plan === 'annual' ? STRIPE_ANNUAL : STRIPE_MONTHLY;
  const checkoutUrl = userId ? `${baseUrl}?client_reference_id=${userId}` : baseUrl;

  const handleCheckout = () => {
    sessionStorage.setItem('trp_pending_checkout', 'paywall');
    window.location.href = checkoutUrl;
  };

  return (
    <div
      className="modal-overlay open"
      onClick={e => e.target.classList.contains('modal-overlay') && onClose()}
    >
      <div className="modal">
        <div className="modal-header">
          <h2>⚡ TradeReady Pro Access</h2>
          <p>Full question banks, code references &amp; lessons for Canadian &amp; US trades exams</p>
        </div>
        <div className="modal-body">
          <div className="signup-flow-header" style={{ marginBottom: '1rem' }}>
            <div className="signup-flow-step">Step 1: Choose your plan</div>
            <div className="signup-plan-picker" style={{ marginBottom: '0.75rem' }}>
              <button
                type="button"
                className={`signup-plan ${plan === 'monthly' ? 'selected' : ''}`}
                aria-pressed={plan === 'monthly'}
                onClick={() => setPlan('monthly')}
              >
                <div className="signup-plan-name">Monthly</div>
                <div className="signup-plan-price"><span className="price-was">$24.99</span> $9.99<span>/mo</span></div>
              </button>
              <button
                type="button"
                className={`signup-plan ${plan === 'annual' ? 'selected' : ''}`}
                aria-pressed={plan === 'annual'}
                onClick={() => setPlan('annual')}
              >
                <div className="signup-plan-name">Annual <span className="plan-badge">SAVE 34%</span></div>
                <div className="signup-plan-price">$199.00<span>/yr</span></div>
              </button>
            </div>
          </div>
          <button
            type="button"
            onClick={handleCheckout}
            className="btn-checkout"
          >
            🔒 Continue to Secure Checkout
          </button>
          <div className="stripe-note">🔐 Payments securely processed by Stripe</div>
          <div className="modal-close" onClick={onClose}>No thanks, maybe later</div>
        </div>
      </div>
    </div>
  );
}

export default SubscribeModal;
